import $ from "jquery";

import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import pauseAutoScrollOffscreen from "./pauseAutoScrollOffscreen";

const weAreCoWorkersTop = (el) => {
    let $el = $(el);

    if ($el.length === 0) {
        throw new Error(
            "Element not found for Swiper initialization [WeAreCoWorkersTop-Swiper]"
        );
    }
    // Set per block in the CMS; 1 is the original speed.
    const speed = parseFloat(el.dataset.speed) || 1;

    let topSplide = new Splide(el, {
        autoScroll: {
            speed: speed,
        },
        type: "loop",
        autoHeight: true,
        autoWidth: true,
        cloneStatus: false,
        pagination: false,
        arrows: false,
        gap: "2.4rem",
    }).mount({ AutoScroll });

    pauseAutoScrollOffscreen(topSplide);
};

export default weAreCoWorkersTop;
